import { Button } from 'primereact/button';
import React, { CSSProperties, useState } from 'react';
import {
  CreateCalendarScheduleDialog,
  ScheduleType,
} from '../../../../../../../calendar/create-calendar-schedule-dialog';
import { SelectedSlotsState } from '../../../../../../../calendar/tabs/serial/components/time-slots/types/selected-slots';
import { LecturerIdWithActivityTypeId } from '../../../../../../../calendar/tabs/serial/create-lecture-serial-tab';
import { Tooltip } from 'primereact/tooltip';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import globalCourseStore from '../../../../../../../../stores/global-course-store';
import {
  ClassSchedule,
  ExamSessionDetails,
} from '../../../../../../../../api/types/programs/course/exams/response/exam-metadata';
import dateUtils from '../../../../../../../../utils/date-format';
import { examClassScheduleDeleteOperations } from './operations/exam-class-schedule-delete-operations';
import globalProgramStore from '../../../../../../../../stores/program-store';

const columnStyle: CSSProperties = {
  textAlign: 'right',
  minWidth: '30px',
  maxWidth: '30px',
};

interface ExamPageClassScheduleTabDatamodel {
  classesSchedule?: ClassSchedule[];
  onApprove: (
    selectedSlotsState: SelectedSlotsState,
    lecturesIdsWithActivityTypeId: LecturerIdWithActivityTypeId[],
    setIsLoadingCreateLectures: (loading: boolean) => any,
    onHide: () => any,
  ) => any;
  examId: number;
  examSession: ExamSessionDetails | null;
  setSessionDetails: (sessions: ExamSessionDetails[]) => any;
}

export const ExamPageClassScheduleTab: React.FC<
  ExamPageClassScheduleTabDatamodel
> = ({
  classesSchedule,
  onApprove,
  examId,
  examSession,
  setSessionDetails,
}) => {
  const [addSchedule, setAddSchedule] = useState(false);

  const currentCourse = globalCourseStore.getCurrentCourse();

  const onApproveAddNewSchedule = (
    selectedSlotsState: SelectedSlotsState,
    lecturesIdsWithActivityTypeId: LecturerIdWithActivityTypeId[],
    setIsLoadingCreateLectures: (loading: boolean) => any,
  ) =>
    onApprove(
      selectedSlotsState,
      lecturesIdsWithActivityTypeId,
      setIsLoadingCreateLectures,
      () => setAddSchedule(false),
    );

  const handleDelete = async (scheduleId: number) => {
    const programId = globalProgramStore.getCurrentId();
    const currentCourseId = globalCourseStore.getCurrentCourse()?.metadata.id;
    await examClassScheduleDeleteOperations(
      programId,
      currentCourseId,
      examId,
      examSession?.id,
      scheduleId,
      setSessionDetails,
    );
  };

  return (
    <div>
      {addSchedule && (
        <CreateCalendarScheduleDialog
          branchId={
            globalProgramStore.programs.get(globalProgramStore.getCurrentId())
              .metadata.branchId
          }
          courseName={'asd'}
          onApprove={onApproveAddNewSchedule}
          supportMultiple={true}
          timeSlot={
            examSession.sessionDate ||
            (classesSchedule && classesSchedule.length > 0)
              ? {
                  start: new Date(
                    classesSchedule && classesSchedule.length > 0
                      ? classesSchedule[0].startAt
                      : examSession.sessionDate,
                  ),
                  end: new Date(
                    classesSchedule && classesSchedule.length > 0
                      ? classesSchedule[0].endAt
                      : examSession.sessionDate,
                  ),
                  classId: classesSchedule && classesSchedule[0]?.classId,
                }
              : null
          }
          onHide={() => setAddSchedule(false)}
          scheduleType={ScheduleType.EXAM}
        />
      )}

      <DataTable
        emptyMessage={<div style={{ textAlign: 'right' }}>לא נמצאו נתונים</div>}
        selectionMode={'multiple'}
        multiple={true}
        groupRowsBy="dsf"
        value={classesSchedule ?? []}
        scrollable
        onSelectionChange={(e) => {
          //setSelectedUsers(e.value as UserSummaryType[]);
        }}
        dataKey="id"
        tableStyle={{
          direction: 'rtl',
          marginTop: '16px',
        }}
      >
        <Column
          expander={false}
          header="שם"
          field={'className'}
          style={columnStyle}
          /*body={(rowData: UserSummaryType) => (
            <label>
              {rowData.firstName} {rowData.lastName}
            </label>
          )}*/
        />

        <Column
          expander={false}
          header="שעת התחלה"
          field={'className'}
          style={columnStyle}
          body={(rowData: ClassSchedule) => (
            <label>{dateUtils.displayFormatDate(rowData.startAt)}</label>
          )}
        />

        <Column
          expander={false}
          header="שעת סיום"
          field={'className'}
          style={columnStyle}
          body={(rowData: ClassSchedule) => (
            <label>{dateUtils.displayFormatDate(rowData.endAt)}</label>
          )}
        />

        <Column
          expander={false}
          header={
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'center',
                paddingRight: '9px',
              }}
            >
              <Button
                icon="pi pi-plus"
                tooltip={
                  examSession?.sessionDate
                    ? 'לבחירת שיבוץ'
                    : 'יש לבחור תאריך בחינה'
                }
                disabled={!examSession?.sessionDate}
                style={{ height: '30px', width: '30px' }}
                tooltipOptions={{ position: 'top', showOnDisabled: true }}
                className="p-button-rounded p-button-primary"
                onClick={() => setAddSchedule(true)}
              />
            </div>
          }
          field={'createdByName'}
          style={columnStyle}
          body={(rowData: ClassSchedule) => (
            <Button
              icon="pi pi-trash"
              text
              severity="danger"
              onClick={() => handleDelete(rowData.scheduleId)}
            />
          )}
        />
      </DataTable>
    </div>
  );
};
